var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66659 8.25012H5.49972C5.49998 8.58611 5.68565 8.90952 6.00664 9.07001C6.45945 9.29642 7.01007 9.11288 7.23648 8.66007L7.44145 8.25012H14.5584L14.7634 8.66007C14.9898 9.11288 15.5404 9.29642 15.9932 9.07001C16.3142 8.90952 16.4999 8.58611 16.5001 8.25012H18.3333V10.0835H3.66659V8.25012ZM15.6914 6.41678H18.3333C19.3458 6.41678 20.1666 7.23759 20.1666 8.25012V10.0835C20.1666 10.8535 19.6919 11.5126 19.0191 11.7842C19.0223 11.828 19.0239 11.8722 19.0239 11.9168C19.0239 12.0505 19.0092 12.1839 18.9802 12.3145L17.5543 18.7312C17.3679 19.57 16.6239 20.1668 15.7646 20.1668H6.23524C5.37596 20.1668 4.63197 19.57 4.44557 18.7312L3.01964 12.3145C2.97995 12.1359 2.96778 11.9576 2.98032 11.784C2.30779 11.5124 1.83325 10.8533 1.83325 10.0835V8.25012C1.83325 7.23759 2.65406 6.41678 3.66659 6.41678H6.30839L8.34669 2.34017C8.5731 1.88736 9.12372 1.70382 9.57653 1.93023C10.0293 2.15663 10.2129 2.70725 9.98648 3.16007L8.35812 6.41678H13.6417L12.0134 3.16007C11.787 2.70725 11.9705 2.15663 12.4233 1.93023C12.8761 1.70382 13.4267 1.88736 13.6531 2.34017L15.6914 6.41678ZM4.80932 11.9168H17.1905L15.7646 18.3334H6.23524L4.80932 11.9168Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.b1d6aece6a58305fdef5284bcba81491.svg";
export { ForwardRef as ReactComponent };